import React from 'react';
import './HowItWorks.css';
import { useLanguage } from '../LanguageContext';
import bottleIcon from '../assets/images/how-1.png';
import compassIcon from '../assets/images/how-2.png';
import chatIcon from '../assets/images/how-3.png';

const HowItWorks = () => {
  const { t } = useLanguage();
  
  return (
    <div className="how-it-works">
      <h2 className="section-title">
        {t('howItWorksTitle1')} <span className="highlight-text">{t('howItWorksTitle2')}</span>?
      </h2>
      
      <div className="methods-container">
        <div className="method-card">
          <div className="method-icon">
            <img src={bottleIcon} alt="Message in a bottle" className="icon-image" />
          </div>
          <h3 className="method-title">
            <span className="highlight-orange">{t('method1Title1')}</span> {t('method1Title2')}
          </h3>
          <p className="method-description">
            {t('method1Desc')}
          </p>
        </div>

        <div className="method-card">
          <div className="method-icon">
            <img src={compassIcon} alt="Compass" className="icon-image" />
          </div>
          <h3 className="method-title">
            {t('method2Title')}
          </h3>
          <p className="method-description">
            {t('method2Desc')}
          </p>
        </div>

        <div className="method-card">
          <div className="method-icon">
            <img src={chatIcon} alt="Chat" className="icon-image" />
          </div>
          <h3 className="method-title">
            {t('method3Title1')} <span className="highlight-orange">{t('method3Title2')}</span>
          </h3>
          <p className="method-description">
            {t('method3Desc')}
          </p>
        </div>
      </div>
      
      <div className="scroll-indicator">↓</div>
    </div>
  );
};

export default HowItWorks;
